export const associateCassetaJson = [
  {
    label: "Cassetta",
    attr: "cassetta",
    index: 0,
    value: null,
  },
  {
    label: "Deposito",
    attr: "riserva",
    index: 0,
    value: null,
  },
  {
    label: "Scaffale",
    attr: "scaffale",
    index: 0,
    value: null,
  },
  {
    label: "Piano",
    attr: "piano",
    index: 0,
    value: null,
  },
  {
    label: "Ripiano",
    attr: "ripiano",
    index: 0,
    value: null,
  },
  {
    label: "Note",
    attr: "note",
    index: 0,
    value: null,
  },
  {
    label: "Dati Frontalino",
    attr: "frontalino",
    index: 0,
    value: null,
  },
  {
    label: "Anno di Scavo",
    attr: "annoScavo",
    index: 0,
    value: null,
  },
];

export const tipoJson = [
  { label: "ambiente", value: "ambienti" },
  { label: "insula", value: "insulae" },
  { label: "quadrato", value: "quadrati" },
  { label: "saggio", value: "saggi" },
  { label: "scavo", value: "scavi" },
  { label: "settore", value: "settori" },
  { label: "sito", value: "siti" },
  { label: "strada", value: "strade" }, 
  { label: "strato", value: "strati" },
  { label: "taglio", value: "tagli" },
  { label: "trincea", value: "trincee" }
];
